<template>
	<div>
		<bv-top></bv-top>
		<van-panel :title="item.title" :desc="item.summary">
			<div v-html="item.content"></div>
		</van-panel>
	</div>
</template>

<script>

	import { Panel} from 'vant'
	import Top from '@/views/components/Top'
	import {selectArticle} from '@/api/public/article'

	export default {
		name: 'ArticleInfo',
		components: {
			BvTop:Top,
			VanPanel: Panel
		},
		data() {
			return {
				smallLogo: require('@/assets/small-logo.png'),
				label: decodeURIComponent(this.$route.query.label),
				value: this.$route.query.value,
				sysGuid: this.$route.query.sysGuid,
				item: {}
			}
		},
		methods: {
			toPublishList() {
				this.$router.push({
					path: '/public/articelList',
					query: {
						value: this.value,
						label: this.label
					}
				})
			}
		},
		mounted() {
			selectArticle(this.sysGuid).then(res => {
				this.item = res.data
			})
		}
	}
</script>
<style>
	p img {
		width: 94vw;
		margin-left: 3vw;
	}
</style>